import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

export default function DefaultSliderValue({
  boundaries,
  defaultValue,
  handleDefaultValue,
  handleFormValidation,
}) {
  const { t } = useTranslation();
  // defaultValue validation
  const getValidation = (value) => {
    // don't validate if defaultValue is empty
    if (value === null) return true;
    return (
      Number(value) >= Number(boundaries[0].value) &&
      Number(value) <= Number(boundaries[1].value)
    );
  };

  const handleChange = (event) => {
    const value = event.target.value;
    let newValue = Number(value);
    if (value === "") newValue = null;
    handleDefaultValue(newValue);
    handleFormValidation(getValidation(newValue));
  };

  return (
    <Box display="flex" justifyContent={"space-between"} alignItems={"center"} gap={2}>
      <Typography>{t("editor.conditionalDialog.defaultValue")}</Typography>
      <TextField
        label=""
        type="number"
        error={!getValidation(defaultValue)}
        value={defaultValue}
        sx={{ maxWidth: 60, textAlignLast: "center" }}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
        variant="standard"
      />
    </Box>
  );
}
